import { PanelLeftClose, PanelLeftOpen } from 'lucide-react';

import { Button } from '@/ui/primitives/button';
import { Dica } from '@/ui/primitives/tooltip';

import { atalhoMenu } from './use-menu-recolhido';

interface AlternarMenuProps {
  recolhida: boolean;
  aoAlternar: () => void;
  /** id da região que o botão mostra/esconde (a lista de navegação). */
  controla: string;
}

/**
 * Controle do menu lateral, no topo junto da marca. O nome acessível é fixo ("Menu lateral") e o
 * estado vai em `aria-expanded`; a dica diz a ação e o atalho.
 */
export function AlternarMenu({ recolhida, aoAlternar, controla }: AlternarMenuProps) {
  const atalho = atalhoMenu();
  return (
    <Dica texto={`${recolhida ? 'Expandir menu' : 'Recolher menu'} · ${atalho}`}>
      <Button
        variante="fantasma"
        tamanho="icone-sm"
        aria-label="Menu lateral"
        aria-expanded={!recolhida}
        aria-controls={controla}
        aria-keyshortcuts={atalho === '⌘B' ? 'Meta+B' : 'Control+B'}
        onClick={aoAlternar}
        className="shrink-0 text-texto-fraco hover:text-texto"
      >
        {recolhida ? <PanelLeftOpen aria-hidden /> : <PanelLeftClose aria-hidden />}
      </Button>
    </Dica>
  );
}
